import { FC } from 'react'
import { classNames, findChildByType } from '@/utils/methods'
import { Title } from '@/components/Basic/Title'
import { Text } from '@saasalerts/ui'

// using a slots pattern here: https://medium.com/@srph/react-imitating-vue-slots-eab8393f96fd
// https://spectrum.chat/react/help/jsx-element-type-component-does-not-have-any-construct-or-call-signatures~033f76eb-6181-4d25-b95c-928b91203f31

interface Component {
  Title: FC<React.PropsWithChildren<unknown>>
  Description: FC<React.PropsWithChildren<unknown>>
  Chart: FC<React.PropsWithChildren<unknown>>
  Explanation: FC<React.PropsWithChildren<unknown>>
  Footer: FC<React.PropsWithChildren<unknown>>
}
type ChartLayoutPropsType = {
  fullWidth?: boolean
  className?: string
}
const Description: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Text>{children}</Text>
)

const Chart: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div
    className={classNames(
      'relative min-h-[80px] max-w-screen-2xl echartContainer'
    )}
  >
    {children}
  </div>
)
const Explanation: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div>
    <Text>{children}</Text>
  </div>
)

const Footer: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className="hidden w-full print:block">{children}</div>
)

export const ChartLayout: Component &
  FC<React.PropsWithChildren<ChartLayoutPropsType>> = ({
  children,
  fullWidth,
  className = '',
}) => {
  const title = findChildByType(children, Title)
  const description = findChildByType(children, Description)
  const chart = findChildByType(children, Chart)
  const explanation = findChildByType(children, Explanation)
  const footer = findChildByType(children, Footer)

  return (
    <div className="flex flex-col justify-between py-8 print:h-full print:p-0">
      <div
        className={classNames(
          'space-y-4 ',
          fullWidth ? 'max-w-screen-2xl' : '',
          className
        )}
      >
        {(title || description) && (
          <div className="print:m-0">
            {title}
            {description}
          </div>
        )}
        {explanation && <div className="hidden print:block">{explanation}</div>}
        {chart}
        {explanation && <div className="block print:hidden">{explanation}</div>}
      </div>
      {footer}
    </div>
  )
}

ChartLayout.displayName = 'ChartLayout'
ChartLayout.Title = Title
ChartLayout.Description = Description
ChartLayout.Chart = Chart
ChartLayout.Explanation = Explanation
ChartLayout.Footer = Footer
